import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetAyudasVisuales = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.get(`/partes/recursos/${params}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getAyudasVisualesMutation: mutation.mutate,
    };
}